import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/noAuthApiClient';
import { userProfilePath } from 'connect-dot-com-ui/consts';
import { useCallback, useMemo } from 'react';
import produce from 'immer';
export const GET_USER_GRANTED_CREDENTIALS = registerQuery({
  fieldName: 'userCredentials',
  args: ['username', 'credentialType', 'topic', 'after', 'count'],

  fetcher({
    username,
    credentialType,
    topic,
    after,
    count
  }) {
    return http.get(`${userProfilePath}/${username}/credentials/granted`, {
      query: Object.assign({}, credentialType && {
        type: credentialType
      }, {}, topic && {
        topic
      }, {}, after && {
        after
      }, {
        count
      })
    });
  }

});
export const useCredentials = ({
  username,
  topic,
  credentialType,
  count
} = {}) => {
  const {
    data,
    error: credentialsError,
    loading: credentialsLoading,
    fetchMore
  } = useQuery(GET_USER_GRANTED_CREDENTIALS, {
    variables: {
      username: username,
      topic,
      credentialType,
      count
    },
    skip: !username,
    notifyOnNetworkStatusChange: true
  });
  const credentials = useMemo(() => data ? data.userCredentials : {
    total: 0,
    results: []
  }, [data]);
  const fetchMoreCredentials = useCallback(() => {
    if (credentials.results && credentials.results.length < credentials.total && credentials.paging) {
      return fetchMore({
        variables: {
          username,
          topic,
          credentialType,
          after: credentials.paging.next.after
        },
        updateQuery: (prev, {
          fetchMoreResult
        }) => {
          if (!fetchMoreResult) return prev;
          return produce(prev, draft => {
            draft.userCredentials.results.push(...fetchMoreResult.userCredentials.results);
            draft.userCredentials.paging = fetchMoreResult.userCredentials.paging;
          });
        }
      });
    }

    return null;
  }, [credentialType, topic, username, credentials, fetchMore]);
  return {
    credentials,
    credentialsError,
    credentialsLoading,
    fetchMoreCredentials
  };
};
export const useAcademyCredentials = username => {
  const {
    credentials: academyCredentials,
    credentialsError: academyCredentialsError,
    credentialsLoading: academyCredentialsLoading,
    fetchMoreCredentials: fetchMoreAcademyCredentials
  } = useCredentials({
    username,
    topic: 'ACADEMY'
  });
  return {
    academyCredentials,
    academyCredentialsError,
    academyCredentialsLoading,
    fetchMoreAcademyCredentials
  };
};
export const useCommunityCredentials = username => {
  const {
    credentials: communityCredentials,
    credentialsError: communityCredentialsError,
    credentialsLoading: communityCredentialsLoading,
    fetchMoreCredentials: fetchMoreCommunityCredentials
  } = useCredentials({
    username,
    topic: 'COMMUNITY'
  });
  return {
    communityCredentials,
    communityCredentialsError,
    communityCredentialsLoading,
    fetchMoreCommunityCredentials
  };
};